/**
 * The Solunary Services tiers, named the way customers see them.
 *
 * ONE list for both planes: the practitioner's Subscription page offers these tiers
 * (`admin/billing/SolunaryServicesCard.jsx`) and the operator's Service leads screen shows
 * which tier a practice asked about. The ids are the backend's `SERVICE_TIERS`
 * (`academy_upsell_routes.py`); the names are product names, identical in every language.
 */
export const SERVICE_TIERS = [
  { id: "pulse", name: "Pulse" },
  { id: "grow", name: "Grow" },
  { id: "studio", name: "Studio" },
  { id: "concierge", name: "Concierge" },
  { id: "executive", name: "Executive" },
];

const NAMES = Object.fromEntries(SERVICE_TIERS.map((tier) => [tier.id, tier.name]));

/** The customer-facing name of a tier id; an id this build does not know stays as it is. */
export const serviceTierName = (id) => NAMES[id] || id;
